<template>
  <div>
    <div style="display: flex; align-items: flex-start">
      <sidebar style="margin-right: 20px; max-width: 200px" />
      <el-card style="width: 100%">
        <div
          slot="header"
          class="clearfix"
        >
          <span>Iktatókönyvek</span>
          <el-button
            style="float: right; margin-top: -5px;"
            type="success"
            size="small"
            @click="$router.replace('/docket/docket-books/add')"
            icon="el-icon-plus"
            v-can="'docketbook.create'"
          >
            Új Iktatókönyv
          </el-button>
        </div>
        <table-filter
          v-if="config"
          :config="config"
          action="docketBook/fetchAll"
        />
        <list />
        <template v-if="$route.meta.showAddDocketBookDialog">
          <docket-book-dialog
            type="add"
          />
        </template>
        <template v-if="$route.meta.showUpdateDocketBookDialog">
          <docket-book-dialog
            :docket-book-id="$route.params.id"
            type="update"
          />
        </template>
      </el-card>
    </div>
  </div>
</template>
<script>
  import Sidebar from '../../components/docket/Sidebar';
  import List from '../../components/docket/docketBooks/List';
  import DocketBookDialog from '../../components/docket/docketBooks/Dialog';
  import TableFilter from '../../components/TableFilter';

  export default {
    components: {
      Sidebar,
      List,
      DocketBookDialog,
      TableFilter,
    },
    data() {
      return {
        config: null,
      };
    },
    methods: {
      async setConfig() {
        let ownCompanies = this.$store.getters['ownCompany/ownCompanies'];
        if(!ownCompanies.length) {
          await this.$store.dispatch('ownCompany/fetchAll');
          ownCompanies = this.$store.getters['ownCompany/ownCompanies'];
        }
        this.config = [
          {
            type: 'text',
            name: 'name',
            label: 'Név',
            defaultSearch: true
          },
          {
            type: 'select',
            name: 'own_company',
            options: ownCompanies,
            label: 'Iroda',
            labelCallback: owc => owc && `${owc.name}` || '',
            valueKey: 'id',
          },
        ];
      }
    },
    async mounted() {
      await this.setConfig();
    }
  };
</script>
